import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InfoModal from '~/entities/evaluations/diligence/InfoModal/InfoModal';
import { RiskToColors } from '~/constants';


const CardButton = styled.button`
  border: 1px solid transparent;
  background-color: white;
  min-width: 224px;
  height: 60px;
  letter-spacing: normal;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding: 0 16px 0 0;
  display: flex; 
  align-items: center;
  text-transform: none;
  font-weight: normal;
  transition: all 0.5s ease;

  &:hover {
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.2); 
    border: 1px solid #d9d9d9;  
    background-color: #F6FCFA;
  }
    `;

const CardColor = styled.div`
  width: 10px;
  background-color: ${props => (props.color)};
  margin-right: 16px;
  height: 100%;
`;

const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.p`
  font-weight: 900;
  display: flex;
  justify-content: flex-start;
  margin-bottom: -3px;
`;

const Subtitle = styled.p`
  display: flex;
  color: #333333;
  font-size: 12px;
`;

const CardNumber = styled.p`
  font-size: 24px;
`;

const CardPropTypes = {
  fraudData: PropTypes.arrayOf(PropTypes.shape({
    low: PropTypes.string,
    high: PropTypes.string,
    description: PropTypes.string,
    model: PropTypes.string,
    service_name: PropTypes.string,
  })),
  riskLevel: PropTypes.string.isRequired,
  score: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
const CardDefaultPropTypes = {
  fraudData: null,
};

function Card({
  fraudData,
  title,
  riskLevel,
  score,
  subtitle,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dataIndex = Object.keys(fraudData).find(value => {
    // Hack for a data integrity issue see comment thread here
    // https://app.clubhouse.io/usealloy/story/12482/create-info-modal-for-add-l-service-score-data
    if (subtitle === 'IDScore') {
      return fraudData[value].model === 'IDScore' && title === fraudData[value].service_name;
    }
    return subtitle === fraudData[value].model && title === fraudData[value].service_name;
  });
  const color = RiskToColors[riskLevel];

  const modalData = fraudData[dataIndex];
  const subtitleStr = modalData && `${modalData.model}:`;
  let description;
  let high;
  let low;
  let model;

  if (modalData) {
    description = modalData.description;
    high = modalData.high;
    low = modalData.low;
    model = modalData.model;
  }

  // Some of the title names are very long and must be shortened. This object maps those long names
  const shortenedTitles = { 'id analytics id score': 'ID Analytics' };
  const shortenedTitle = shortenedTitles[title.toLowerCase()]
    ? shortenedTitles[title.toLowerCase()]
    : title;

  return (
    <CardButton
      type="button"
      onClick={() => setIsModalOpen(true)}
    >
      <CardColor color={color} />
      <FlexContainer>
        <div>
          <Title>
            {shortenedTitle}
            {modalData && (
            <InfoModal
              color={color}
              description={description}
              high={high}
              low={low}
              model={model}
              riskLevel={riskLevel}
              score={score}
              title={title}
              isModalOpen={isModalOpen}
              onToggleModal={event => {
                event.stopPropagation();
                setIsModalOpen(false);
              }}
            />
            )}
          </Title>
          <Subtitle>{subtitleStr}</Subtitle>
        </div>
        <CardNumber>
          {score}
        </CardNumber>
      </FlexContainer>
    </CardButton>
  );
}
Card.propTypes = CardPropTypes;
Card.defaultProps = CardDefaultPropTypes;

export default Card;
